/*
 * action types
 */

export const ACTION = "ACTION";
export const APP_REBOOT = "@APP_REBOOT";
export const APP_INIT_COMPLETE = "@APP_INIT_COMPLETE";
export const SCENE_TRANSITION = "@SCENE_TRANSITION";
export const MODAL_ENABLE = "@MODAL_ENABLE";
export const MODAL_DISABLE = "@MODAL_DISABLE";
export const SOUND_CHANGE = "@SOUND_CHANGE";
export const ADD_SCORE = "@ADD_SCORE";
export const START_GAME = "@START_GAME";
export const STAGE_INIT = "@STAGE_INIT";
export const STAGE_CLEAR = "@STAGE_CLEAR";
export const STAGE_CONTINUE = "@STAGE_CONTINUE";
export const GAME_CLEAR = "@GAME_CLEAR";
export const GAME_OVER = "@GAME_OVER";
export const GAME_PAUSE = "@GAME_PAUSE";
export const GAME_RESUME = "@GAME_RESUME";
export const ROTATE_BOX = "@ROTATE_BOX";
export const PLACEMENT_BOX = "@PLACEMENT_BOX";
export const DO_DAMAGES = "@DO_DAMAGES";
export const END_COOL_TIME = "@END_COOL_TIME";
export const PLACEMENT_SKILL = "@PLACEMENT_SKILL";
export const DELETE_OBJECT = "@DELETE_OBJECT";
export const CHANGE_OBJECT = "@CHANGE_OBJECT";
export const BREAK_TREASURE = "@BREAK_TREASURE";

/*
 * action creators
 */

function dummyAction(index) {
    return { type: ACTION, index };
}

function reboot() {
    return { type: APP_REBOOT };
}

function initComplete() {
    return { type: APP_INIT_COMPLETE };
}

function sceneTransition(scene) {
    return { type: SCENE_TRANSITION, scene }
}

function modalEnable(modal) {
    return { type: MODAL_ENABLE, modal }
}

function modalDisable() {
    return { type: MODAL_DISABLE }
}

function soundChange() {
    return { type: SOUND_CHANGE }
}

function addScore(score) {
    return {
        type: ADD_SCORE,
        score
    }
}

function startGame(
    playerCharactor,
    playerName,
    score = 0,
    continueCount = 3,
    arrivalStage = 1,
    totalAttack = 0,
    totalDamage = 0,
    totalPlacementPorin = 0,
    totalBreakPorin = 0,
    totalBreakTreasure = 0
) {
    return {
        type: START_GAME,
        score,
        playerName,
        playerCharactor,
        continueCount,
        arrivalStage,
        totalAttack,
        totalDamage,
        totalPlacementPorin,
        totalBreakPorin,
        totalBreakTreasure
    }
}

function initStage(arrivalStage) {
    return {
        type: STAGE_INIT,
        now: new Date().getTime(),
        arrivalStage
    }
}

function continueStage(arrivalStage) {
    return {
        type: STAGE_CONTINUE,
        now: new Date().getTime(),
        arrivalStage
    }
}

function clearStage() {
    return {
        type: STAGE_CLEAR,
        now: new Date().getTime(),
    }
}

function gameClear() {
    return {
        type: GAME_CLEAR,
        now: new Date().getTime(),
    }
}

function gameOver() {
    return {
        type: GAME_OVER,
        now: new Date().getTime(),
    }
}

function gamePause() {
    return {
        type: GAME_PAUSE,
        now: new Date().getTime(),
    }
}

function gameResume(baseTime = 0, skillBaseTime = 0) {
    return {
        type: GAME_RESUME,
        baseTime,
        skillBaseTime,
        now: new Date().getTime(),
    }
}

function rotateBox(boxId) {
    return {
        type: ROTATE_BOX,
        boxId
    }
}

function placementBox(objectArray, frameId) {
    return {
        type: PLACEMENT_BOX,
        objectArray,
        frameId
    }
}

function doDamages(damageArray) {
    return {
        type: DO_DAMAGES,
        damageArray,
    }
}

function endCoolTime() {
    return {
        type: END_COOL_TIME,
        now: new Date().getTime(),
    }
}

function placementSkill() {
    return {
        type: PLACEMENT_SKILL,
        now: new Date().getTime(),
    }
}

function deleteObject(posX, posY) {
    return {
        type: DELETE_OBJECT,
        posX, posY
    }
}

function changeObject(posX, posY, object, hp, bonus, weakness, target, gimmickNo) {
    return {
        type: CHANGE_OBJECT,
        posX, posY, object, hp, bonus, weakness, target, gimmickNo
    }
}

function breakTreasure() {
    return {
        type: BREAK_TREASURE
    }
}

export default {
    dummyAction,
    reboot,
    initComplete,
    sceneTransition,
    modalEnable,
    modalDisable,
    soundChange,
    addScore,
    startGame,
    initStage,
    continueStage,
    clearStage,
    gameClear,
    gameOver,
    gamePause,
    gameResume,
    rotateBox,
    placementBox,
    doDamages,
    endCoolTime,
    placementSkill,
    deleteObject,
    changeObject,
    breakTreasure
}